const actions = {
  setechartsdata ({commit},echartsData){
    commit('setEchartsData',echartsData)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js